import { render, staticRenderFns } from "./special-list.vue?vue&type=template&id=59932712"
import script from "./special-list.vue?vue&type=script&lang=js"
export * from "./special-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports